import React from 'react';
import { Col, Row } from 'antd';

interface Props {
  title: string | undefined;
}

export const TitledContainer: React.FC<Props> = ({ children, title }) => (
  <Row>
    <Col
      xs={24}
      style={{
        marginTop: '10px',
        borderRadius: '5px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
      }}
    >
      <Row>
        <Col
          xs={24}
          style={{
            backgroundColor: '#242A30',
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
            color: 'white',
            padding: '10px',
            fontWeight: 'bold'
          }}
        >
          {title}
        </Col>
      </Row>
      <Row>
        <Col style={{ padding: '20px' }}>{children}</Col>
      </Row>
    </Col>
  </Row>
);
